import { render, staticRenderFns } from "./SlcLegalLinks.vue?vue&type=template&id=5c0859f0&scoped=true&"
var script = {}
import style0 from "./SlcLegalLinks.vue?vue&type=style&index=0&id=5c0859f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0859f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
